import axiosInstance from './axiosInstance';

export const createTrainingVideo = async (trainingVideoData) => {
  try {
    const response = await axiosInstance.post('/training-videos/create', trainingVideoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const startTraining = async (trainingData) => {
  const response = await axiosInstance.post('/training/start-training', trainingData);
  return response.data;
};


export const fetchTrainingVideosByTrainingId = async (trainingId) => {
  try {
    const response = await axiosInstance.get(`/training-videos/${trainingId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching training videos:', error);
    throw error;
  }
};


export const updateTrainingVideo = async (videoData) => {
  try {
    const response = await axiosInstance.post('/training-videos/update', videoData);
    return response.data;
  } catch (error) {
    console.error('Error updating training video:', error);
    throw error;
  }
};

export const deleteTrainingVideo = async (videoId) => {
  try {
    const response = await axiosInstance.post('/training-videos/delete', { videoId });
    return response.data;
  } catch (error) {
    console.error('Error deleting training video:', error);
    throw error;
  }
};